// import React from "react";
// import { Grid } from "@mui/material";
// import {
//   AccountCircleOutlined,
//   DnsOutlined,
//   VerifiedUserOutlined,
// } from "@mui/icons-material";
// import AppStatTile from "../../../components/AppStatTile";
// import {
//   primaryColor,
//   infoColor,
//   successColor,
//   MESSAGES,
// } from "../../../constants/consts";

// export default function ContextSummary({ username, sunucuKodu }) {
//   return (
//     <Grid container spacing={2}>
//       <Grid item xs={12} md={4}>
//         <AppStatTile
//           icon={AccountCircleOutlined}
//           label={MESSAGES.STAT_ACTIVE_USER}
//           value={username || MESSAGES.STAT_ACCOUNT}
//           color={primaryColor}
//         />
//       </Grid>
//       <Grid item xs={12} md={4}>
//         <AppStatTile
//           icon={DnsOutlined}
//           label={MESSAGES.STAT_SUNUCU_KODU}
//           value={sunucuKodu || "-"}
//           color={infoColor}
//         />
//       </Grid>
//       <Grid item xs={12} md={4}>
//         <AppStatTile
//           icon={VerifiedUserOutlined}
//           label={MESSAGES.STAT_PORTAL_STATUS}
//           value={MESSAGES.STAT_PORTAL_ACTIVE}
//           color={successColor}
//         />
//       </Grid>
//     </Grid>
//   );
// }
import React from "react";
import { Grid, Box } from "@mui/material";
import { keyframes } from "@mui/system"; // ← EKLE
import {
  AccountCircleOutlined,
  DnsOutlined,
  VerifiedUserOutlined,
} from "@mui/icons-material";
import AppStatTile from "../../../components/AppStatTile";
import {
  primaryColor,
  infoColor,
  successColor,
  MESSAGES,
} from "../../../constants/consts";

const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const tileAnim = (delay) => ({
  animation: `${fadeInUp} 0.5s cubic-bezier(0.22, 1, 0.36, 1) ${delay}s backwards`,
});

export default function ContextSummary({ username, sunucuKodu }) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <Box sx={tileAnim(0.3)}>
          <AppStatTile
            icon={AccountCircleOutlined}
            label={MESSAGES.STAT_ACTIVE_USER}
            value={username || MESSAGES.STAT_ACCOUNT}
            color={primaryColor}
          />
        </Box>
      </Grid>

      <Grid item xs={12} md={4}>
        <Box sx={tileAnim(0.38)}>
          <AppStatTile
            icon={DnsOutlined}
            label={MESSAGES.STAT_SUNUCU_KODU}
            value={sunucuKodu || "-"}
            color={infoColor}
          />
        </Box>
      </Grid>

      <Grid item xs={12} md={4}>
        <Box sx={tileAnim(0.46)}>
          <AppStatTile
            icon={VerifiedUserOutlined}
            label={MESSAGES.STAT_PORTAL_STATUS}
            value={MESSAGES.STAT_PORTAL_ACTIVE}
            color={successColor}
          />
        </Box>
      </Grid>
    </Grid>
  );
}
